import React from "react";
import { NavLink } from "react-router-dom";
import Container from "../../../../modules/commons/Container";
import FlexView from "react-flexview";

const menuItems = [
  {
    label: "Prospek Monitoring",
    link: "/dashboard/crm-kabeng-kacab/prospek-monitoring",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_prospek_monitoring_h23",
  },
  {
    label: "Prospek Daily",
    link: "/dashboard/crm-kabeng-kacab/prospek-daily",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_prospek_daily_h23",
  },
  {
    label: "Monitoring RO",
    link: "/dashboard/crm-kabeng-kacab/monitoring-ro",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_monitoring_ro_h23",
  },
  {
    label: "Monitoring KPB",
    link: "/dashboard/crm-kabeng-kacab/monitoring-kpb",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_monitoring_kpb_h23",
  },
  {
    label: "Monitoring Tambahan",
    link: "/dashboard/crm-kabeng-kacab/monitoring-tambahan",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_monitoring_tambahan_h23",
  },
];

const DashboardCRMKabengKacab = () => {
  return (
    <React.Fragment>
      <Container>
        <FlexView style={{ gap: "20px" }}>
          {menuItems.map((item) => (
            <NavLink key={item.id} id={item.id} to={item.link}>
              <FlexView
                column
                vAlignContent="center"
                hAlignContent="center"
                className="background-red txt-site txt-white"
                style={{
                  width: 235,
                  height: 235,
                  border: "2px solid #000",
                  borderRadius: 5,
                  gap: "10px",
                }}
              >
                <i className={`${item.icon} fa-lg`}></i>
                <div className="text-center">{item.label}</div>
              </FlexView>
            </NavLink>
          ))}
        </FlexView>
      </Container>
    </React.Fragment>
  );
};

export default DashboardCRMKabengKacab;
